module.exports = __webpack_public_path__ + "static/media/code.916d19ff.svg";